const DEFAULT_LANG = 'en';

export { DEFAULT_LANG };
